// extracted by mini-css-extract-plugin
export default {"hero":"HeroSection-module__hero--T2PDS","logos":"HeroSection-module__logos--GSTy9","pillars":"HeroSection-module__pillars--CONgG"};